import saveAs from 'file-saver';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as FileDoc } from '../../../assets/svg/file-doc.svg';
import { SOURCE_MAP } from '../../../const';
import { AccessPermissionExt, AccessPermissionFull, AccessPermissionStatus, useGetMediaHeaderMutation, useLazyGetAccessPermissionDocxQuery, useLazyGetAccessPermissionPdfQuery, useLazyGetAccessPermissionQuery } from '../../../services/content_v1';
import { BASE_URL } from '../../../services/reauth';
import { useAlert } from '../../alert';
import { extractErrorDetail, formatBytes, toMplatDate, useIsAdmin, useIsProvider } from '../../common';
import Button from '../Button/Button';
import { toSourceParams } from '../Deals/DealContentConsumer';
import { Modal } from '../Modal';
import NoHideEmailAdmin from '../NoHide/NoHideEmailAdmin';
import NoHideFIOAdmin from '../NoHide/NoHideFIOAdmin';
import NoHidePhoneAdmin from '../NoHide/NoHidePhoneAdmin';
import { PermissionViewModalProps } from './types';


export function PermissionViewModal({ isOpen, permId, onClose }: PermissionViewModalProps) {
    const alert = useAlert();
    const navigate = useNavigate();
    const isAdmin = useIsAdmin();
    const isProvider = useIsProvider();

    const [fetchPermission, { data: permData }] = useLazyGetAccessPermissionQuery();
    const [fetchPdf] = useLazyGetAccessPermissionPdfQuery();
    const [fetchDocx] = useLazyGetAccessPermissionDocxQuery();
    // const { data: refBooks } = useGetReferenceBookQuery();
    const [getHeader] = useGetMediaHeaderMutation();

    const [success, setSuccess] = useState<boolean>();
    const [fail, setFail] = useState<string>();

    const [perm, setPerm] = useState<AccessPermissionFull | undefined>(undefined);

    const successClass = 'popup_message';

    // const tvSourceDict = useMemo(() => {
    //     if (refBooks?.results) {
    //         const tmp = refBooks.results.tvsource.reduce((acc, curr) => {
    //             acc[curr.id] = curr.displayname;
    //             return acc;
    //         }, {} as Record<number, string>);
    //         refBooks.results.tvsat.reduce((acc, curr) => {
    //             acc[curr.id] = curr.displayname;
    //             return acc;
    //         }, tmp)
    //         return tmp;
    //     }
    //     return {};
    // }, [refBooks]);

    useEffect(() => {
        if (isOpen) {
            fetchPermission(permId).unwrap().catch((err) => setFail(extractErrorDetail(err)));
            setSuccess(false);
            setFail('');
        }
    }, [isOpen]);

    useEffect(() => {
        if (permData?.results) {
            setPerm(permData?.results);
        }
    }, [permData]);

    return (
        <Modal className={success ? successClass : 'form-opinion'} isOpen={isOpen} onClose={() => onClose()}>
            {fail}
            {perm &&
                <div className="permission__channels-view">
                    {perm.status === AccessPermissionStatus.REVOKED && <>
                        <p>
                            <span style={{ color: 'red' }}><Trans>Permission</Trans> ID{perm.id} <Trans>ISSUED</Trans> {perm.issued && toMplatDate(perm.issued, true)} <Trans>REVOKED</Trans> {perm.revoked && toMplatDate(perm.revoked, true)}</span>
                        </p>
                    </>}
                    {perm.status === AccessPermissionStatus.ISSUED && <>
                        <p>
                            <span style={{ color: 'green' }}><Trans>Permission</Trans> ID{perm.id} <Trans>ISSUED</Trans> {perm.issued && toMplatDate(perm.issued, true)}</span>
                        </p>
                        {perm.external === AccessPermissionExt.EXTERNAL && <p>
                            <span style={{ color: 'green' }}>
                                <Trans>order:PERMISSION_EXTERNAL_DISCLAMER</Trans>
                            </span>
                        </p>}
                        {perm.contracts.length > 0 &&
                            <p>
                                <span style={{ color: 'green' }}><Trans>To contract</Trans> № {perm.contracts[0].number} <Trans>component:VALUE_FROM</Trans> {toMplatDate(perm.contracts[0].validity?.lower, true)}</span>
                            </p>
                        }
                    </>}
                    {perm.status === AccessPermissionStatus.WORKING &&
                        <p>
                            <span style={{ color: 'gray' }}><Trans>Draft</Trans> ID{perm.id}</span>
                        </p>
                    }
                    <p>
                        {perm.issuer_accs?.length && perm.external === AccessPermissionExt.NORMAL ?
                            <>
                                <strong>
                                    {perm.issuer_accs.map((acc) => acc.org.name || acc.name).join(', ')}
                                </strong>
                                {' '}
                                <Trans>order:PERMISSION_FROM_MANY_TO</Trans>
                            </>
                            :
                            <>
                                <strong>{perm.issuer.org?.name || perm.issuer.name}</strong>
                                {' '}
                                <Trans>order:PERMISSION_FROM_TO</Trans>
                            </>
                        }
                        {' '}
                        <strong>{perm.recipient.org?.name || perm.recipient.name}</strong>
                        {' '}
                        <Trans>order:PERMISSION_FROM_TO_TV</Trans>
                    </p>
                    <div className="permission__channels-view-channels">
                        <table>
                            <thead>
                                <tr>
                                    <td className="_name"><Trans>TV channel</Trans></td>
                                    <td className="_format"><Trans>order:TV_QUALITY</Trans></td>
                                    <td className="_licence"><Trans>order:TV_MEDIA_LIC</Trans></td>
                                    <td className="_comment"><Trans>order:TV_VERSION</Trans></td>
                                </tr>
                            </thead>
                            <tbody>
                                {perm.units.map((unit) => <tr key={unit.unit.id}>
                                    <td className="_name">{unit.unit.title}</td>
                                    <td className="_format">{unit.fmt.map((f) => f.name).join(', ')}</td>
                                    <td className="_licence">{unit.unit.mmcertno} {unit.unit.licno && ` · ${unit.unit.licno}`}</td>
                                    <td className="_comment">{unit.version}</td>
                                </tr>)}
                            </tbody>
                        </table>
                    </div>
                    <h3>
                        <Trans>order:IN_SOURCES</Trans>:
                    </h3>
                    <ul>
                        {perm.details.sources?.map((s) => <li key={s.stype}>
                            <Trans>{SOURCE_MAP[s.stype]}</Trans>
                            {s.sources && <>
                                <br />- {s.sources.map((ss) => {
                                    // const srcOrg = perm.tvsrcpartners.find((tvsrc) => tvsrc.srcids.includes(ss.id))?.org.name;
                                    // if (ss.info?.org) {
                                    //     return `${ss.name} "${ss.info.org}"`;
                                    // } else if (srcOrg) {
                                    //     return `${ss.name} "${srcOrg}"`;
                                    // }
                                    return ss.name;
                                }).join(', ')}
                            </>}
                            <br />
                            {toSourceParams(s.params)}
                        </li>)}
                        {!perm.details.sources && <li><Trans>account:NOT_SPECIFIED</Trans></li>}
                    </ul>

                    {!!perm.details?.additional && <>
                        <h3><Trans>order:SPEC_CONDITIONS</Trans></h3>
                        <p>
                            {perm.details.additional}
                        </p>
                    </>}

                    {/* {perm.contracts.length && <>
                        <h3><Trans>order:LIC</Trans></h3>
                        <p>
                            {perm.contracts[0].number} {perm.contracts[0].validity?.lower ? `от ${toMplatDate(perm.contracts[0].validity?.lower, true)}` : ''}
                        </p>
                    </>} */}

                    <h3><Trans>order:PERMISSION_PERIOD</Trans></h3>
                    <p>
                        <Trans>order:PERMISSION_PERIOD_FROM</Trans> {perm.validity.lower ? toMplatDate(perm.validity.lower, true) : t('order:PERMISSION_PERIOD_FROM_TODAY')}
                        &nbsp;
                        <Trans>order:PERMISSION_PERIOD_TO</Trans> {perm.validity.upper ? toMplatDate(perm.validity.upper, true) : t('order:PERMISSION_PERIOD_TO_REVOKE')}
                    </p>

                    <h3><Trans>order:PERMISSION_ISSUER</Trans></h3>
                    <p>
                        {/* <Link to={`/accounts/${perm.issuer.id}`} className="link-accent">
                            @{perm.issuer.nickname || perm.issuer.id}
                        </Link> */}
                        <NoHideFIOAdmin user={perm.issuerperson} />, <br />
                        <NoHidePhoneAdmin user={perm.issuerperson} />, <br />
                        <NoHideEmailAdmin user={perm.issuerperson} />
                    </p>

                    {perm.files.length > 0 && <>
                        <h3><Trans>order:PERMISSION_REASON</Trans></h3>
                        <p>
                            {perm.files.map((f) => <div
                                key={f.id}
                                className="order__files-item"
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    getHeader(BASE_URL.substring(0, BASE_URL.length - 1) + f.url).then(() => {
                                        window.open(BASE_URL.substring(0, BASE_URL.length - 1) + f.url);
                                    }).catch((err) => {
                                        alert.error(extractErrorDetail(err));
                                    });
                                }}
                            >
                                <div className="order__files-item-name">{f.name}</div>
                                <div className="order__files-item-size">{formatBytes(f.size)}</div>
                            </div>)}
                        </p>
                    </>}

                    <p className="permission__channels-view-cta">
                        {perm.external === AccessPermissionExt.EXTERNAL ?
                            ((isAdmin || isProvider) && (perm.status === AccessPermissionStatus.WORKING) &&
                                <Button onClick={() => navigate(`/access/permissions/ext/${perm.id}`)}>
                                    <Trans>order:PERMISSION_EDIT</Trans>
                                </Button>
                            ) :
                            (isProvider && (perm.status === AccessPermissionStatus.WORKING) &&
                                <Button onClick={() => navigate(`/access/permissions/${perm.id}`)}>
                                    <Trans>order:PERMISSION_EDIT</Trans>
                                </Button>
                            )
                        }
                        {isProvider && (perm.status !== AccessPermissionStatus.WORKING) &&
                            <Link to="" className="main__types-file" onClick={(ev) => {
                                ev.preventDefault();
                                fetchPdf(perm.id).unwrap().then((data) => {
                                    saveAs(data, `permission_${perm.id}.pdf`);
                                }).catch((err) => {
                                    alert.error(extractErrorDetail(err));
                                });
                            }}>
                                <FileDoc />
                                <Trans>order:LOAD_PDF</Trans>
                            </Link>
                        }
                        {(isProvider || isAdmin) && (perm.status === AccessPermissionStatus.WORKING) &&
                            <Link to="" className="main__types-file" onClick={(ev) => {
                                ev.preventDefault();
                                fetchDocx(perm.id).unwrap().then((data) => {
                                    saveAs(data, `permission_${perm.id}.docx`);
                                }).catch((err) => {
                                    alert.error(extractErrorDetail(err));
                                });
                            }}>
                                <FileDoc />
                                <Trans>order:LOAD_DOCX</Trans>
                            </Link>
                        }
                    </p>
                </div>
            }
        </Modal>
    );
}
